export default "__VITE_ASSET__C6jeYa6y__"